/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const SET_ACCOUNT_REGISTER = 'mbp-member/SET_ACCOUNT_REGISTER';
export const SET_ACCOUNT_MESSAGE = 'mbp-member/SET_ACCOUNT_MESSAGE';
